var _ellipse, _ellipse2, _mask, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 28,
    viewBox: "0 0 17 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8496_4368)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.3125,
    cy: 23.6252,
    rx: 8.3125,
    ry: 4.375,
    fill: "black",
    fillOpacity: 0.35
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.4873,
    cy: 23.1001,
    rx: 6.5625,
    ry: 3.5,
    fill: "black",
    fillOpacity: 0.35
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_8496_4368",
    maskUnits: "userSpaceOnUse",
    x: 1.68652,
    y: -0.354492,
    width: 14,
    height: 27,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.68652,
    y: -0.354492,
    width: 14,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0653 10.2235C10.5203 9.52231 10.7551 8.35243 11.3558 7.69829C12.0436 6.94943 12.466 5.93398 12.466 4.81572C12.466 2.51258 10.6739 0.645508 8.46325 0.645508C6.25256 0.645508 4.46045 2.51258 4.46045 4.81572C4.46045 5.91424 4.86815 6.91356 5.53451 7.6584C6.1279 8.32166 6.34837 9.50075 5.80033 10.202C2.1967 14.8128 2.63714 21.7843 2.78502 23.3186C2.80468 23.5226 2.88314 23.7095 3.03019 23.8522C3.57917 24.385 5.23515 25.6667 8.46119 25.6667C11.6906 25.6667 13.3467 24.3822 13.8939 23.8505C14.0398 23.7087 14.118 23.5236 14.1379 23.3211C14.2876 21.8058 14.7287 14.9366 11.0653 10.2235Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0653 10.2235C10.5203 9.52231 10.7551 8.35243 11.3558 7.69829C12.0436 6.94943 12.466 5.93398 12.466 4.81572C12.466 2.51258 10.6739 0.645508 8.46325 0.645508C6.25256 0.645508 4.46045 2.51258 4.46045 4.81572C4.46045 5.91424 4.86815 6.91356 5.53451 7.6584C6.1279 8.32166 6.34837 9.50075 5.80033 10.202C2.1967 14.8128 2.63714 21.7843 2.78502 23.3186C2.80468 23.5226 2.88314 23.7095 3.03019 23.8522C3.57917 24.385 5.23515 25.6667 8.46119 25.6667C11.6906 25.6667 13.3467 24.3822 13.8939 23.8505C14.0398 23.7087 14.118 23.5236 14.1379 23.3211C14.2876 21.8058 14.7287 14.9366 11.0653 10.2235Z",
    fill: "url(#paint0_linear_8496_4368)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8939 23.8505L13.5687 23.5158L13.8939 23.8505ZM14.1379 23.3211L14.6024 23.367L14.1379 23.3211ZM2.78502 23.3186L2.32051 23.3634L2.78502 23.3186ZM3.03019 23.8522L3.3552 23.5173L3.03019 23.8522ZM5.80033 10.202L5.43265 9.91458L5.80033 10.202ZM11.3558 7.69829L11.0121 7.38263L11.3558 7.69829ZM11.9994 4.81572C11.9994 5.81495 11.6222 6.7183 11.0121 7.38263L11.6995 8.01395C12.4649 7.18056 12.9327 6.05301 12.9327 4.81572H11.9994ZM8.46325 1.11217C10.3984 1.11217 11.9994 2.7521 11.9994 4.81572H12.9327C12.9327 2.27305 10.9495 0.178841 8.46325 0.178841V1.11217ZM4.92712 4.81572C4.92712 2.7521 6.52813 1.11217 8.46325 1.11217V0.178841C5.97699 0.178841 3.99378 2.27305 3.99378 4.81572H4.92712ZM5.88231 7.34724C5.29108 6.68639 4.92712 5.79733 4.92712 4.81572H3.99378C3.99378 6.03116 4.44522 7.14073 5.18671 7.96955L5.88231 7.34724ZM3.24954 23.2738C3.1775 22.5264 3.03288 20.4375 3.34874 17.9733C3.66533 15.5034 4.43888 12.7018 6.16802 10.4893L5.43265 9.91458C3.55815 12.313 2.75011 15.3025 2.42298 17.8546C2.09513 20.4124 2.24467 22.5765 2.32051 23.3634L3.24954 23.2738ZM8.46119 25.2001C5.37383 25.2001 3.83038 23.9785 3.3552 23.5173L2.70519 24.1871C3.32796 24.7915 5.09647 26.1334 8.46119 26.1334V25.2001ZM13.5687 23.5158C13.0953 23.9759 11.5518 25.2001 8.46119 25.2001V26.1334C11.8295 26.1334 13.5982 24.7886 14.2192 24.1852L13.5687 23.5158ZM10.6969 10.5099C12.4581 12.7758 13.2456 15.5798 13.5689 18.0325C13.8915 20.4806 13.7463 22.5382 13.6735 23.2753L14.6024 23.367C14.6792 22.5886 14.8294 20.454 14.4942 17.9105C14.1596 15.3714 13.336 12.3844 11.4338 9.93715L10.6969 10.5099ZM14.2192 24.1852C14.4558 23.9552 14.5733 23.6617 14.6024 23.367L13.6735 23.2753C13.6627 23.3854 13.6239 23.4622 13.5687 23.5158L14.2192 24.1852ZM2.32051 23.3634C2.34907 23.6597 2.46673 23.9557 2.70519 24.1871L3.3552 23.5173C3.29954 23.4633 3.26029 23.3854 3.24954 23.2738L2.32051 23.3634ZM5.18671 7.96955C5.41591 8.22573 5.58314 8.5969 5.63272 8.9764C5.68246 9.35713 5.60823 9.68993 5.43265 9.91458L6.16802 10.4893C6.54048 10.0128 6.63003 9.40543 6.55819 8.8555C6.48619 8.30434 6.2465 7.75432 5.88231 7.34724L5.18671 7.96955ZM11.0121 7.38263C10.6435 7.78399 10.3969 8.32904 10.3189 8.87758C10.241 9.42506 10.3252 10.0318 10.6969 10.5099L11.4338 9.93715C11.2604 9.71406 11.1894 9.38524 11.2429 9.00894C11.2963 8.6337 11.4674 8.26673 11.6995 8.01395L11.0121 7.38263Z",
    fill: "#922413",
    mask: "url(#path-3-outside-1_8496_4368)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8496_4368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 13,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0653 10.2235C10.5203 9.52231 10.7551 8.35243 11.3558 7.69829C12.0436 6.94943 12.466 5.93398 12.466 4.81572C12.466 2.51258 10.6739 0.645508 8.46325 0.645508C6.25256 0.645508 4.46045 2.51258 4.46045 4.81572C4.46045 5.91424 4.86815 6.91356 5.53451 7.6584C6.1279 8.32166 6.34837 9.50075 5.80033 10.202C2.1967 14.8128 2.63714 21.7843 2.78502 23.3186C2.80468 23.5226 2.88314 23.7095 3.03019 23.8522C3.57917 24.385 5.23515 25.6667 8.46119 25.6667C11.6906 25.6667 13.3467 24.3822 13.8939 23.8505C14.0398 23.7087 14.118 23.5236 14.1379 23.3211C14.2876 21.8058 14.7287 14.9366 11.0653 10.2235Z",
    fill: "url(#paint1_linear_8496_4368)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8496_4368)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8496_4368)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92177 10.2237C9.37672 9.52244 9.61151 8.35255 10.2123 7.69841C10.9 6.94956 11.3225 5.9341 11.3225 4.81584C11.3225 2.5127 9.53038 0.64563 7.31969 0.64563C5.10901 0.64563 3.3169 2.5127 3.3169 4.81584C3.3169 5.91437 3.7246 6.91368 4.39095 7.65852C4.98434 8.32179 5.20481 9.50087 4.65678 10.2021C1.05314 14.8129 1.49359 21.7844 1.64147 23.3187C1.66113 23.5227 1.73958 23.7096 1.88664 23.8523C2.43561 24.3851 4.0916 25.6669 7.31763 25.6669C10.5471 25.6669 12.2032 24.3824 12.7504 23.8506C12.8963 23.7089 12.9744 23.5237 12.9944 23.3212C13.144 21.8059 13.5852 14.9368 9.92177 10.2237Z",
    fill: "url(#paint2_linear_8496_4368)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8496_4368)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20595 10.2237C7.6609 9.52244 7.89569 8.35255 8.49645 7.69841C9.18419 6.94956 9.60667 5.9341 9.60667 4.81584C9.60667 2.5127 7.81456 0.64563 5.60387 0.64563C3.39319 0.64563 1.60107 2.5127 1.60107 4.81584C1.60107 5.91437 2.00877 6.91368 2.67513 7.65852C3.26852 8.32179 3.48899 9.50087 2.94096 10.2021C-0.662677 14.8129 -0.222232 21.7844 -0.0743519 23.3187C-0.0546919 23.5227 0.0237604 23.7096 0.170818 23.8523C0.719794 24.3851 2.37578 25.6669 5.60181 25.6669C8.83127 25.6669 10.4873 24.3824 11.0346 23.8506C11.1804 23.7089 11.2586 23.5237 11.2786 23.3212C11.4282 21.8059 11.8694 14.9368 8.20595 10.2237Z",
    fill: "url(#paint3_linear_8496_4368)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8496_4368)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46094 25.6532C5.60934 25.5136 4.11751 24.3528 3.60197 23.8524C3.45491 23.7097 3.37646 23.5228 3.3568 23.3188C3.20892 21.7845 2.76847 14.813 6.37211 10.2022C6.92015 9.50099 6.69967 8.32191 6.10629 7.65864C5.43993 6.9138 5.03223 5.91449 5.03223 4.81596C5.03223 2.71516 6.52329 0.977173 8.463 0.688013C8.27618 0.660162 8.0852 0.645752 7.89098 0.645752C5.6803 0.645752 3.88818 2.51282 3.88818 4.81596C3.88818 5.91449 4.29588 6.9138 4.96224 7.65864C5.55563 8.32191 5.7761 9.50099 5.22807 10.2022C1.62443 14.813 2.06488 21.7845 2.21276 23.3188C2.23242 23.5228 2.31087 23.7097 2.45793 23.8524C3.0069 24.3852 4.66289 25.667 7.88892 25.667C8.08538 25.667 8.27602 25.6622 8.46094 25.6532Z",
    fill: "#86081E",
    fillOpacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter3_f_8496_4368)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.40684,
    cy: 2.57931,
    rx: 2.40684,
    ry: 2.57931,
    transform: "matrix(0.982006 0.188849 -0.174462 0.984664 5.36914 0.959412)",
    fill: "#FFFDF2"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_8496_4368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39067 3.68776C6.20611 4.26724 6.03644 4.75861 5.73669 4.65499C5.43695 4.55137 5.34358 3.99762 5.52813 3.41814C5.71269 2.83866 6.10529 2.45289 6.40504 2.55651C6.70478 2.66013 6.57523 3.10828 6.39067 3.68776Z",
    fill: "#FFFDF6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_8496_4368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.17478 25.6669C3.48859 19.4711 5.79496 13.1562 7.03392 10.7733C5.66153 14.8243 5.89027 22.5889 6.17619 25.9647L4.17478 25.6669Z",
    fill: "url(#paint4_linear_8496_4368)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M4.1744 25.6669C3.48821 19.4711 4.46033 13.4541 7.03354 10.7733C5.31807 14.9435 5.01896 22.5889 5.30488 25.9647L4.1744 25.6669Z",
    fill: "url(#paint5_linear_8496_4368)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8496_4368",
    x: -1.08203,
    y: -1.97937,
    width: 16.7998,
    height: 30.2712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3125,
    result: "effect1_foregroundBlur_8496_4368"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8496_4368",
    x: -2.50619,
    y: -1.6877,
    width: 16.2165,
    height: 29.6879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16667,
    result: "effect1_foregroundBlur_8496_4368"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8496_4368",
    x: 0.947591,
    y: -0.520915,
    width: 8.68197,
    height: 27.3546,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.583333,
    result: "effect1_foregroundBlur_8496_4368"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8496_4368",
    x: 2.54264,
    y: -0.960165,
    width: 9.48014,
    height: 9.82774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16667,
    result: "effect1_foregroundBlur_8496_4368"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_8496_4368",
    x: 4.85026,
    y: 1.95634,
    width: 2.31608,
    height: 3.29588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291667,
    result: "effect1_foregroundBlur_8496_4368"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_8496_4368",
    x: 1.71647,
    y: 8.43992,
    width: 7.65104,
    height: 19.8581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16667,
    result: "effect1_foregroundBlur_8496_4368"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8496_4368",
    x1: 8.46152,
    y1: 0.645508,
    x2: 8.46152,
    y2: 25.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#F02D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D90B49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8496_4368",
    x1: 8.46152,
    y1: 0.645508,
    x2: 8.46152,
    y2: 25.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#1639D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8496_4368",
    x1: 7.31797,
    y1: 0.64563,
    x2: 7.31797,
    y2: 25.6669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#F32C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD0F0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8496_4368",
    x1: 5.60215,
    y1: 0.64563,
    x2: 5.60215,
    y2: 25.6669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63685,
    stopColor: "#F56C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E62711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8496_4368",
    x1: 5.54186,
    y1: 10.7733,
    x2: 5.54186,
    y2: 25.9647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8496_4368",
    x1: 6.74764,
    y1: 11.6669,
    x2: 5.43934,
    y2: 25.9554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546216,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842262,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8496_4368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTokenIcon);
export default __webpack_public_path__ + "static/media/red-token-icon.65e0d3d17b05978280fbdc118b81bcdf.svg";
export { ForwardRef as ReactComponent };